<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-default" style="margin-bottom: 10px;">
          <div
            class="panel-heading"
            @click.prevent="collapsed = !collapsed"
            style="cursor: pointer;"
          >
            <a>
              <i class="fa" :class="{ 'fa-plus': collapsed, 'fa-minus': !collapsed }" />
              Contabilista
            </a>
          </div>

          <div class="row" v-if="!collapsed" style="padding-bottom: 15px;">
            <div class="col-sm-12">
              <br />
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="">Contabilista:</label>
                  <multiselect
                    style="z-index: 9999;"
                    @select="changeContabilista"
                    :disabled="contabilistaFieldsDisabled"
                    :block-keys="['Tab']"
                    :value="empresa.contabilista"
                    :options="contabilistas"
                    :allow-empty="false"
                    track-by="id"
                    label="nome"
                    placeholder="Selecione um contabilista"
                    selectLabel="Selecionar"
                    selectedLabel="Selecionado"
                    deselect-label=""
                  >
                    <div slot="noResult">
                      Nenhum resultado encontrado!
                    </div>
                  </multiselect>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label for="">Tipo Contabilista:</label>
                  <multiselect
                    style="z-index: 9999;"
                    v-model="empresa.contabilista.tipo"
                    :disabled="contabilistaFieldsDisabled"
                    @select="changeContabilistaTipo"
                    :block-keys="['Tab']"
                    :options="contabilistasTipos"
                    :allow-empty="false"
                    track-by="id"
                    label="descricao"
                    placeholder="Selecione um tipo"
                    selectLabel="Selecionar"
                    selectedLabel="Selecionado"
                    deselect-label=""
                  >
                    <div slot="noResult">
                      Nenhum resultado encontrado!
                    </div>
                  </multiselect>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="pull-right" style="margin: 20px 10px 5px;">
                <button
                  class="btn edit-badge"
                  style="margin-left: 5px;"
                  @click.prevent="contabilistaFieldsDisabled = !contabilistaFieldsDisabled"
                >
                  Editar
                </button>
                <button
                  class="btn btn-primary"
                  @click.prevent="updateContabilista"
                  :disabled="contabilistaFieldsDisabled"
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmpresaService from '../../services/EmpresaService'
import Multiselect from 'vue-multiselect'
import { Empresa } from '../../models/Empresa'
import ContabilistaService from '../../services/ContabilistaService'

export default {
  name: 'contabilista',
  data() {
    return {
      collapsed: true,
      contabilistaFieldsDisabled: true,
      empresa: new Empresa(),
      contabilistas: [],
      contabilistasTipos: [],
      modalContabilista: false
    }
  },

  mounted() {
    this.retrieveContabilistas()
    this.retrieveContabilistasTipos()
    this.retrieveLastContabilistas()
  },

  methods: {
    async retrieveLastContabilistas() {
      try {
        const { data = {} } = await EmpresaService.retrieveLastContabilista({ idEmpresa: this.empresaSelecionada.id })
        if (data.length) {
          this.empresa.contabilista = [{ nome: data[0].contabilista, id: data[0].idContabilista }]
          this.empresa.contabilista.tipo = { descricao: data[0].tipoContabilista, id: data[0].idTipo }
        }
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível buscar o último contabilista.')
        console.error(e)
      }
    },

    async updateContabilista() {
      try {
        if (!this.empresa.contabilista.id || !this.empresa.contabilista.tipo.id) {
          this.$messages
            .error('Preencha todos os campos obrigatórios.')
            .toast('Não foi possível atualizar o contabilista.')
          return
        }
        await EmpresaService.insertContabilista(this.queryUpdate)
        this.$messages.success().toast('Contabilista atualizado com sucesso !')
        this.$emit('on-update-contabilista')
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível atualizar o contabilista.')
        console.error(e)
      } finally {
        this.contabilistaFieldsDisabled = true
      }
    },

    changeContabilista(contabilista) {
      contabilista.status = 'INSERT'
      this.empresa.contabilista = contabilista
    },

    changeContabilistaTipo(contabilistaTipo) {
      this.empresa.contabilista.tipo = contabilistaTipo
    },

    async retrieveContabilistas() {
      try {
        let pesquisa = { value: '', limit: 1000, offset: 0 }
        const data = await ContabilistaService.retrieve(pesquisa)
        this.contabilistas = data.body.data
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível buscar os contabilistas.')
        console.error(e)
      }
    },

    async retrieveContabilistasTipos() {
      try {
        const data = await ContabilistaService.retrieveTipos()
        this.contabilistasTipos = data.body.data
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível buscar os tipos de contabilistas.')
        console.error(e)
      }
    }
  },

  components: {
    Multiselect
  },

  computed: {
    empresaSelecionada() {
      return this.$store.getters.getCompany
    },

    queryUpdate() {
      return {
        idEmpresa: this.empresaSelecionada.id,
        idContabilista: this.empresa.contabilista.id,
        idTipoContabilista: this.empresa.contabilista.tipo.id
      }
    }
  },
  watch: {}
}
</script>

<style lang="css" scoped>
a {
  color: #3c8dbc !important;
}

.edit-badge {
  background-color: #52baf7;
  font-size: 13px;
  color: white;
  padding: 1px 4px;
  border-radius: 5px;
  /* margin-right: 5px; */
  margin: 5px 5px;
  cursor: pointer;
}
</style>
